import { Pipe, PipeTransform } from '@angular/core'
import { getSignalStore } from '@src/app/core/store/signalStore.js'

@Pipe({
  name: 'localize',
  standalone: false,
})
export class LocalizePipe implements PipeTransform {
  transform(obj?: any, options?: any): string {
    if (obj?.toLocaleString) {
      return obj.toLocaleString(getSignalStore().$lang() || 'en-US', options)
    }
    return `${obj}`
  }
}
